export function fiDebounce(func, wait?, scope?) {
    let timer;

    return function fiDebounced() {
        const context = scope,
            args = Array.prototype.slice.call(arguments);

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(function () {
            timer = undefined;
            func.apply(context, args);
        }, wait || 10);
    };
}
